<template>
  <Drawer
    placement="left"
    :closable="false"
    v-model="openPoint"
    width="280"
    draggable
    class="my-drawer"
    title="电子围栏"
  >
    <div id="pointList">
      <Input
        v-model="keyword"
        search
        placeholder="请输入关键字"
        @on-search="getList"
      ></Input>

      <ul>
        <li
          @click="clickItem(item)"
          v-for="(item, index) in tableData"
          :key="index"
          :class="{ active: item.select }"
        >
          <div>
            {{ item.name }}
          </div>
          <div>
            <Icon
              title="编辑"
              @click.stop="opemUpdate(item)"
              class="icon"
              type="md-checkmark-circle-outline"
            />
            <Icon
              title="删除"
              @click.stop="del(item)"
              class="icon"
              type="md-close"
            />
          </div>
        </li>
      </ul>

      <Row :gutter="10">
        <Col span="12">
          <Button
            long
            @click="checkAll"
            :disabled="selectData.length == 0"
            type="primary"
            >取消选择</Button
          > </Col
        ><Col span="12">
          <Button long @click="openAdd" type="success">新增</Button></Col
        >
      </Row>
    </div>
    <fence ref="fence" v-if="openOut" @ok="open1" :outUse="true"></fence>
  </Drawer>
</template>
<script>
import fence from "../rule/ruleFence.vue";
export default {
  components: { fence },
  data() {
    return {
      openPoint: false,
      openOut:false,
      tableData: [],
      selectData: [],
      isAll: false,
      keyword: "",
      isLoad: false, //是否已经请求过列表
      isAdd: true,
      forms: [
        {
          title: "名称",
          key: "name",
          type: "Input",
          required: true,
          span: 6,
        },
        {
          title: "容许时长",
          key: "duration",
          key2: "duration2",
          required: true,

          type: "Select",
          selectType: "obj",
          selectItems: this.$t("times1"),
          span: 6,
        },
        {
          title: "围栏类型",
          key: "type",
          key2: "fenceType2",
          type: "Select1",
          st: "fenceType",
          span: 6,
          required: true,
        },
      ],
      item: {
        coordList: [],
        cs: 2, //	坐标系（1-WGS84，2-GCJ-02，3-BD-09）
        enabled: true,
        name: "",
        type: "1", //类型（1-禁出，2-禁入）
        duration: 60,
        remark: "",
        timeList: [],
        weekList: [],
      },
    };
  },
  methods: {
    open() {
      this.openPoint = true;
      if (!this.isLoad) {
        this.getList();
      }
    },
    open1() {
      this.openPoint = true;
      this.openOut=false;
      this.getList();
    },
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.rule + "/fence/list",
        data: { keyword: this.keyword },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].select = false;
          data[i].hasItem = false;
        }
        //var data = [{ name: "11111" }];
        this.tableData = data;
        this.isLoad = true;
      });
    },
    getItem(row) {
      if (row.hasItem) {
        return;
      }
      this.utils.loading(this, "加载中");

      this.axios({
        method: "post",
        url: this.axios.rule + "/fence/item",
        data: { id: row.id },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          var data = res.data.data.coordList;

          row.coordList = data;
          row.hasItem = true;
          this.$emit("fences", this.selectData);
        }
      });
    },
    push() {
      this.selectData = [];

      for (const i in this.tableData) {
        if (this.tableData[i].select) {
          this.selectData.push(this.tableData[i]);
          this.getItem(this.tableData[i]);
          //如果还没详情
          if (!this.tableData[i].hasItem) {
          }
        }
      }
      this.$emit("fences", this.selectData);
    },
    clickItem(v) {
      v.select = !v.select;

      this.push();
    },
    checkAll() {
      for (const i in this.tableData) {
        this.tableData[i].select = false;
      }
      this.selectData = [];
      this.$emit("fences", this.selectData);
    },

    del(row, n) {
      if (row.select) {
        this.clickItem(row);
      }
      this.openPoint = false;
      this.openOut=true;
      setTimeout(() => {
        this.$refs.fence.del(row);
      }, 200);
    },
    //点击编辑按钮
    opemUpdate(row) {
      if (row.select) {
        this.clickItem(row);
      }
      this.isAdd = false;
      this.openPoint = false;
      this.openOut=true;
      setTimeout(() => {
        this.$refs.fence.opemUpdate(row);
      }, 200);
    },
    openAdd() {
      this.isAdd = true;
      this.openPoint = false;
      this.openOut=true;
      setTimeout(() => {
        this.$refs.fence.openAdd();
      }, 200);
    },
  },
  mounted() {},
};
</script>
<style lang="">
#pointList {
  height: 100%;
}
#pointList ul {
  height: calc(100% - 80px);
  margin: 10px auto;
  overflow: auto;
}
#pointList li {
  padding: 10px;
  cursor: pointer;
}
#pointList li.active {
  background: #d9ebfe;
}
</style>


// WEBPACK FOOTER //
// src/components/common/fenceList.vue